import React, {useState, useEffect} from 'react';
import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import ModalXLogo from "../../../../assets/sidebarIcon/Sidebarcompanylogo.png";
import { useNavigate } from 'react-router-dom';

// Import components
import Dashboard from './VoiceAgent_Components/Dashboard';
import Contacts from './VoiceAgent_Components/Contacts';
import VoiceAgents from './VoiceAgent_Components/VoiceAgents';
import Automation from './VoiceAgent_Components/Automation';
import LLMAgent from './VoiceAgent_Components/LLMAgent';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import Usage from './VoiceAgent_Components/Usage';
import BusinessProfile from './VoiceAgent_Components/BusinessProfile';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const Sidebar = styled(Box)(({ theme }) => ({
  width: '282px',
  height: '100vh',
  borderRight: '1px solid rgba(255, 255, 255, 0.10)',
  background: '#141626',
  color: '#CAC4D0',
  padding: theme.spacing(2),
  position:"fixed",
  top: 0,
  left: 0,
}));

const Content = styled(Box)({
  marginLeft: '282px', // Same width as Sidebar
  height: '100vh',
  overflowY: 'auto',
  backgroundColor: '#101220',
  padding: '36px 36px 0px 36px',
  flexGrow: 1,
});

// const Content = styled(Box)({
//   flexGrow: 1,
//   padding: '24px',
// });

const SidebarButton = styled(ListItemButton)({
  borderRadius: '4px',
  padding: '8px 12px',
  marginBottom: '4px',
  '&.Mui-selected': {
    backgroundColor: 'rgba(255, 255, 255, 0.10)',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
  },
});

const SidebarText = styled(ListItemText)({
  '& .MuiTypography-root': {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '20px',
  },
});

const SectionTitle = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.80)',
  fontFamily: 'Inter',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '20px',
  marginTop: '16px',
  marginBottom: '8px',
  paddingLeft: '12px',
});

const components = {
  0: Dashboard,
  1: Contacts,
  2: VoiceAgents,
  3: Automation,
  4: LLMAgent,
  5: Usage,
  6: BusinessProfile
};
const UsageId = ["choudharypratiksha007@gmail.com", "makarand@modalx.ai"]

const VoiceAgent = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const navigate = useNavigate();

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const SelectedComponent = components[selectedIndex];

  return (
    <Box display="flex">
      <Sidebar>
        {/* Logo */}
        <Box sx={{ width: "140px", height: "40px", marginBottom: '24px' }}>
          <img width={"140px"} height={"40px"} src={ModalXLogo} alt="logo" />
        </Box>

        {/* Back to Workspace */}
        <List>
          <ListItem disablePadding>
            <SidebarButton sx={{ borderRadius:"8px", maxHeight:"36px" ,color:"rgba(255, 255, 255, 0.9)",   '&:hover': { backgroundColor: "rgba(40, 45, 81, 1)",
            }}} onClick={() => navigate('/workspace')}>
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <ArrowBackIcon sx={{ fontSize: '20px', }} />
              </ListItemIcon>
              <SidebarText primary="Back to workspace" />
            </SidebarButton>
          </ListItem>

          <Box sx={{}}>
            <Box sx={{display:"flex", flexDirection:"row", padding:"8px 12px", alignItems:"center", marginBottom:'12px', color:"rgba(255, 255, 255, 0.9)", }}>
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <SupportAgentIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Voice Agents for Business" />
            </Box>
          </Box>

          <Divider  sx={{bgcolor:"#FFFFFF", opacity: 0.2}}  />

          {/* Dashboard */}
          <ListItem disablePadding>
            <SidebarButton  sx={{ marginTop:"24px",color:"rgba(255, 255, 255, 0.9)", backgroundColor: selectedIndex == 0 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" , '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)", 
            }}}
              selected={selectedIndex === 0}
              onClick={() => handleListItemClick(0)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px"  }}>
                <SpaceDashboardOutlinedIcon sx={{ fontSize: '20px', transform: 'rotate(90deg) scaleX(1)'}} />
              </ListItemIcon>
              <SidebarText primary="Dashboard" />
            </SidebarButton>
          </ListItem>

          {/* CUSTOMERS Section */}
          <SectionTitle sx={{color:"rgba(255, 255, 255, 0.9)" }}>CUSTOMERS</SectionTitle>
          <ListItem disablePadding>
            <SidebarButton  sx={{color:"rgba(255, 255, 255, 0.9)",  backgroundColor: selectedIndex == 1 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" ,    '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)",
            }}}
              selected={selectedIndex === 1}
              onClick={() => handleListItemClick(1)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <ContactsOutlinedIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Contacts" />
            </SidebarButton>
          </ListItem>

          {/* COMMUNICATION Section */}
          <SectionTitle sx={{color:"rgba(255, 255, 255, 0.9)" }}>COMMUNICATION</SectionTitle>
          <ListItem disablePadding>
            <SidebarButton  sx={{color:"rgba(255, 255, 255, 0.9)", 
             backgroundColor: selectedIndex == 2 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" ,  '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)",
            }}}
              selected={selectedIndex === 2}
              onClick={() => handleListItemClick(2)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <CallOutlinedIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Voice agents" />
            </SidebarButton>
          </ListItem>
          
          {/* <ListItem disablePadding>
            <SidebarButton
              selected={selectedIndex === 3}
              onClick={() => handleListItemClick(3)}
            >
              <ListItemIcon sx={{ minWidth: '24px', color: 'inherit' }}>
                <SmartToyIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Automation" />
            </SidebarButton>
          </ListItem> */}

          {/* AI MODELS Section */}
          <SectionTitle sx={{color:"rgba(255, 255, 255, 0.9)" }}>AI MODELS</SectionTitle>
          <ListItem disablePadding>
            <SidebarButton  sx={{color:"rgba(255, 255, 255, 0.9)",  backgroundColor: selectedIndex == 4 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" ,    '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)",
            }}}
              selected={selectedIndex === 4}
              onClick={() => handleListItemClick(4)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <ChatOutlinedIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="LLM Agent" />
            </SidebarButton>
          </ListItem>

          {/* ACCOUNT Section */}
          <SectionTitle sx={{color:"rgba(255, 255, 255, 0.9)" }}>ACCOUNT</SectionTitle>
          {
            UsageId.includes(localStorage.getItem("userEmail")) ? 
         <ListItem disablePadding>
            <SidebarButton  sx={{color:"rgba(255, 255, 255, 0.9)",  backgroundColor: selectedIndex == 5 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" ,   '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)",
            }}}
              selected={selectedIndex === 5}
              onClick={() => handleListItemClick(5)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <InsertChartOutlinedIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Usage" />
            </SidebarButton>
          </ListItem> : null
          }
          
          <ListItem disablePadding>
            <SidebarButton  sx={{color:"rgba(255, 255, 255, 0.9)",  backgroundColor: selectedIndex == 6 ? "rgba(31, 35, 62, 1) !important" : null, borderRadius:"8px", maxHeight:"36px" ,   '&:hover': {
              backgroundColor: "rgba(40, 45, 81, 1)",
            }}}
              selected={selectedIndex === 6}
              onClick={() => handleListItemClick(6)}
            >
              <ListItemIcon sx={{ minWidth: '20px', color: 'inherit', marginRight:"12px" }}>
                <StoreOutlinedIcon sx={{ fontSize: '20px' }} />
              </ListItemIcon>
              <SidebarText primary="Business Profile" />
            </SidebarButton>
          </ListItem>
        </List>
      </Sidebar>

      <Content>
          <SelectedComponent/>
       </Content>
     
    </Box>
  );
};

export default VoiceAgent;